import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, ReplaySubject } from 'rxjs';
import { map, tap, first } from 'rxjs/operators';

import { SessionService } from '../session/session.service';
import { FeatureFlags } from './feature-flags.enum';
import { FeatureFlagsResult } from './feature-flags-result.model';

@Injectable({
    providedIn: 'root'
})
export class FeatureFlagService {
    private readonly httpClient = inject(HttpClient);
    private readonly sessionService = inject(SessionService);

    private readonly featureFlags$: ReplaySubject<{ [key: string]: boolean }>;

    constructor() {
        this.featureFlags$ = new ReplaySubject<{ [key: string]: boolean }>(1);
    }

    public init(): Observable<void> {
        return this.requestFeatureFlags().pipe(
            tap(result => this.featureFlags$.next(result.featureFlags)),
            map(() => null)
        );
    }

    public isEnabled(featureFlag: FeatureFlags): Observable<boolean> {
        return this.featureFlags$.pipe(
            first(),
            map(flag => flag[featureFlag])
        );
    }

    private requestFeatureFlags(): Observable<FeatureFlagsResult> {
        const url = `${this.sessionService.getApiUrl()}/feature_flags/${this.sessionService.requestId}`;
        return this.httpClient.get<FeatureFlagsResult>(url);
    }
}
